/**
 * Maximum TokenId value (2^256 - 1)
 */
export const MAX = (1n << 256n) - 1n;

/**
 * Minimum TokenId value (0)
 */
export const MIN = 0n;
